import { type RefObject, useCallback, useRef, useState } from "react";

export interface EntriesShellContainerState {
	pageRef: RefObject<HTMLDivElement>;
	shellContainer: HTMLElement | null;
	handlePageRef: (node: HTMLDivElement | null) => void;
}

export function useEntriesShellContainer(): EntriesShellContainerState {
	const pageRef = useRef<HTMLDivElement | null>(null);
	const [shellContainer, setShellContainer] = useState<HTMLElement | null>(
		null,
	);

	const handlePageRef = useCallback((node: HTMLDivElement | null) => {
		pageRef.current = node;
		setShellContainer(node?.closest("main")?.parentElement ?? null);
	}, []);

	return { pageRef, shellContainer, handlePageRef };
}
